import { dateDiffMilliseconds, getNow, User } from 'model';

export function checkSuspended(user: User | undefined): boolean {
	if (user && user.suspendedUntil !== '') {
		const daysUntilSuspensionEnds = dateDiffMilliseconds(getNow(), user.suspendedUntil);
		if (daysUntilSuspensionEnds > 0) {
			return true;
		}
	}
	return false;
}
